/* eslint-disable @typescript-eslint/no-explicit-any */
//import { Link } from "react-router-dom";
import { useState } from "react";
import excursiones from "../../../../assets/img/excursiones.png";
import excursiones_ from "../../../../assets/img/excursión-3.png";
import excursiones__ from "../../../../assets/img/excursion3.png";
import Actividad from "./Actividad";
import Descripcion from "./Descripcion";
import Horarios from "./Horarios";
import Imagenes from "./Imagenes";
import Precio from "./Precio";
import { FORMs } from "../../../../conts/Property";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { myHeaders } from "../../../../config/axios";
import { URL_API } from "../../../../config/default";
import Tipo from "./Tipo";
import { CustomToast } from "../../../../utils/custom-toast";
import { useNavigate } from "react-router-dom";

const PasosExcursion = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [label, setLabel] = useState(0);
  const [form, setForm] = useState(JSON.parse(JSON.stringify(FORMs.EXCURSION)));

  const pasos = () => {
    switch (label) {
      case 0:
        return (
          <div className="h-[100%] flex justify-center items-center">
            <div className="grid lg:grid-cols-2 gap-10 py-5 px-5">
              <div>
                <span className="text-primary font-bold text-xl">Paso 1</span>
                <span className="block font-bold my-3">
                  Contanos acerca de tu excursión
                </span>

                <div className="mb-5">
                  <span className="block">
                    En este paso, te vamos a preguntar que tipo de actividades
                    realizas.
                  </span>
                </div>
              </div>
              <div>
                <img src={excursiones} alt="" width={250} />
              </div>
            </div>
          </div>
        );
        break;
      case 1:
        {
          return <Tipo setForm={setForm} form={form} />;
        }
        break;
      case 2:
        return <Actividad setForm={setForm} form={form} />;
        break;
      case 3:
        return (
          <div className="h-[100%] flex justify-center items-center">
            <div className="grid lg:grid-cols-2 gap-10 py-5 px-5">
              <div>
                <span className="text-primary font-bold text-xl">Paso 2</span>
                <span className="block font-bold my-3">
                  Hacé que tu excursión se destaque
                </span>

                <div className="mb-5">
                  <span className="block">
                    En este paso, contanos más sobre tu excursión, vas a tener
                    que crear un título o una descripción. Luego, agregá cinco
                    fotos o más.
                  </span>
                </div>
              </div>
              <div>
                <img src={excursiones_} alt="" width={250} />
              </div>
            </div>
          </div>
        );
        break;
      case 4:
        return <Descripcion setForm={setForm} form={form} />;
        break;
      case 5:
        return <Horarios setForm={setForm} form={form} />;
        break;
      case 6:
        return <Imagenes setForm={setForm} form={form} />;
        break;
      case 7:
        return (
          <div className="h-[100%] flex justify-center items-center">
            <div className="grid lg:grid-cols-2 gap-10 py-5 px-5">
              <div>
                <span className="text-primary font-bold text-xl">Paso 3</span>
                <span className="block font-bold my-3">
                  Terminá todo y publicá tu excursión
                </span>

                <div className="mb-5">
                  <span className="block">Vas a establecer el precio.</span>
                </div>
              </div>
              <div className="flex justify-center w-full px-2">
                <img
                  src={excursiones__}
                  alt=""
                  className="w-[300px] h-auto object-cover"
                />
              </div>
            </div>
          </div>
        );
        break;
      case 8:
        return <Precio setForm={setForm} form={form} />;
        break;
      case 9:
        return (
          <div className="h-[100%] flex justify-center items-center">
            <div className="grid lg:grid-cols-2 gap-10 py-5 px-5">
              <div>
                <span className="text-primary font-bold text-xl">Paso 3</span>
                <span className="block font-bold my-3">
                  Es hora de publicar tu excursión
                </span>

                <div className="mb-5">
                  <span className="block">
                    Esto es lo que les vamos a mostrar a los huéspedes. Antes de
                    publicar la excursión, asegúrate de revisar todos los
                    detalles.
                  </span>
                </div>
                <div className="shadow-sm border-0 rounded-2xl px-3 py-3 w-full">
                  <div
                    id="container"
                    className="overflow-hidden relative rounded-xl"
                  >
                    <div
                      className={"relative flex justify-center bg-white"}
                      style={{
                        maxHeight: "300px",
                      }}
                    >
                      <label
                        className="cursor-pointer absolute"
                        style={{ top: "10px", right: "10px", zIndex: 2 }}
                      >
                        <img
                          src="./src/assets/img/favorito3.png"
                          alt=""
                          style={{ width: "20px" }}
                        />
                        <button className="hidden"></button>
                      </label>
                      <Carousel
                        autoPlay={true}
                        //centerMode={true}
                        dynamicHeight={true}
                        infiniteLoop={true}
                        showArrows={false}
                        showStatus={false}
                        showIndicators={false}
                        showThumbs={false}
                      >
                        {form.IMAGES.map((img: any, index: number) => {
                          return (
                            <img
                              src={img.url}
                              alt=""
                              key={index}
                              style={{
                                width: "100%",
                                minHeight: "250px",
                                maxHeight: "250px",
                                objectFit: "cover",
                              }}
                              className="bg-gray-30"
                            />
                          );
                        })}
                      </Carousel>
                    </div>
                    <div className="absolute bottom-3 right-0 left-0"></div>
                  </div>
                  <div className="my-3 text-start">
                    <a
                      className="font-bold"
                      style={{ fontSize: "90%" }}
                      href="#"
                    >
                      {form.title}
                    </a>
                    <p
                      style={{
                        fontSize: "90%",
                        marginBottom: "0px",
                        lineHeight: "1",
                      }}
                    >
                      {form.description}
                    </p>
                    <p className="font-bold " style={{ fontSize: "100%" }}>
                      $
                      {form.price.toLocaleString("de-DE", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}{" "}
                      ARS
                    </p>
                  </div>
                </div>
              </div>
              <div></div>
            </div>
          </div>
        );
        break;
    }
  };

  /*
  function convertFileToBase64(file: any) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = function (event: any) {
        const base64String = event.target.result; // Extract base64 part from the result
        resolve(base64String);
      };

      reader.onerror = function (error) {
        reject(error);
      };

      reader.readAsDataURL(file); // Read the file as a data URL
    });
  }
  */

  const upload = async (excursion: any) => {
    const formdata = new FormData();
    formdata.append("excursion_id", excursion.id);

    for (let index = 0; index < form.IMAGES.length; index++) {
      //const file = await convertFileToBase64(form.IMAGES[index].file);
      formdata.append("file[" + index + "]", form.IMAGES[index].file);
    }

    const requestOptions = {
      method: "POST",
      body: formdata,
      headers: {
        Authorization: myHeaders, // Un ejemplo de header de autenticación
      },
    };

    fetch(`${URL_API}/excursions/upload`, requestOptions)
      .then(async () => {
        CustomToast({
          status: 200,
          msg: "",
          title: "Imagenes cargadas",
        });
        setLoading(false);
        return navigate("/");
      })
      .then((result) => console.log(result))
      .catch((error) => console.error(error));
  };

  const onClick = (e: any) => {
    switch (e.target.name) {
      case "save":
        {
          setLoading(true);
          /* empty */
          //console.log(form);

          let formdata = new FormData();
          formdata.append("title", form.title);
          formdata.append("description", form.description);
          formdata.append("description_long", form.description_long);
          formdata.append("start_date", form.start_date);
          formdata.append("regular_time", form.regular_time);
          formdata.append("duration", String(form.duration));
          formdata.append("type_time", form.type_time);
          formdata.append("space", form.space);
          formdata.append("price", String(form.price));
          formdata.append("status", "activo");

          formdata.append(
            "DESCRIPTION_EXCURSION",
            JSON.stringify(form.DESCRIPTION_EXCURSION)
          );
          formdata.append("ACTIVITIES", JSON.stringify(form.ACTIVITIES));
          formdata.append("AMENITIES", JSON.stringify(form.AMENITIES));

          const requestOptions = {
            method: "POST",
            body: formdata,
            headers: {
              Authorization: myHeaders, // Un ejemplo de header de autenticación
            },
          };

          fetch(`${URL_API}/excursions`, requestOptions)
            .then(async (response) => {
              if (response.ok) {
                const excursion = await response.json();

                if (form.IMAGES.length !== 0) {
                  upload(excursion.data);
                }

                CustomToast({
                  status: 200,
                  msg: "",
                  title: "Excursion creado con exito",
                });
              } else {
                setLoading(false);
                CustomToast({
                  status: 400,
                  msg: "",
                  title: "Ocurrio un error",
                });
              }

              //return navigate("/");
            })
            .then((result) => console.log(result))
            .catch((error) => console.error(error));
        }
        break;
    }
  };

  const next = () => {
    switch (label) {
      case 0:
        {
          return (
            <button
              className={`cursor-pointer flex rounded-full btn btn-filled-2`}
              style={{ borderRadius: "20px" }}
              onClick={() => setLabel(label + 1)}
            >
              Siguiente
            </button>
          );
        }
        break;
      case 1:
        {
          if (form.space !== "") {
            return (
              <button
                className={`cursor-pointer flex rounded-full btn btn-filled-2`}
                style={{ borderRadius: "20px" }}
                onClick={() => setLabel(label + 1)}
              >
                Siguiente
              </button>
            );
          }
        }
        break;
      case 2:
      case 3:
        {
          if (form.ACTIVITIES.length !== 0) {
            return (
              <button
                className={`cursor-pointer flex rounded-full btn btn-filled-2`}
                style={{ borderRadius: "20px" }}
                onClick={() => setLabel(label + 1)}
              >
                Siguiente
              </button>
            );
          }
        }
        break;
      case 4:
        {
          if (
            form.DESCRIPTION_EXCURSION.length !== 0 &&
            form.title.trim() !== "" &&
            form.description.trim() !== ""
          ) {
            return (
              <button
                className={`cursor-pointer flex rounded-full btn btn-filled-2`}
                style={{ borderRadius: "20px" }}
                onClick={() => setLabel(label + 1)}
              >
                Siguiente
              </button>
            );
          }
        }
        break;
      case 5:
        {
          if (
            form.regular_time.trim() !== "" &&
            form.type_time.trim() !== "" &&
            form.start_date.trim() !== ""
          ) {
            return (
              <button
                className={`cursor-pointer flex rounded-full btn btn-filled-2`}
                style={{ borderRadius: "20px" }}
                onClick={() => setLabel(label + 1)}
              >
                Siguiente
              </button>
            );
          }
        }
        break;
      case 6:
        {
          if (form.IMAGES.length !== 0) {
            return (
              <button
                className={`cursor-pointer flex rounded-full btn btn-filled-2`}
                style={{ borderRadius: "20px" }}
                onClick={() => setLabel(label + 1)}
              >
                Siguiente
              </button>
            );
          }
        }
        break;
      default:
        return (
          <button
            className={`cursor-pointer flex rounded-full btn btn-filled-2`}
            style={{ borderRadius: "20px" }}
            onClick={() => setLabel(label + 1)}
          >
            Siguiente
          </button>
        );
    }
  };

  return (
    <div className="mx-auto md:w-[80%] w-full h-[100vh] bg-white rounded-lg shadow-sm border px-1">
      <label className="cursor-pointer flex justify-center hover:bg-gray-20 px-2 py-2 rounded-full text-dark font-bold block w-[100px] my-2">
        <i className="bi bi-chevron-left text-md me-2"></i>Salir
        <button className="hidden" onClick={() => navigate("/publicaciones")}></button>
      </label>
      <div className="h-[70%] overflow-auto">{pasos()}</div>
      <div className="h-[20%] w-full bottom-0 py-4 bg-white">
        <div className="grid grid-cols-3 gap-5">
          <div className="w-full bg-gray-200 rounded-full h-1 dark:bg-gray-700 my-5">
            <div
              className="bg-primary h-1 rounded-full"
              style={{ width: label >= 3 ? "100%" : label * 25 + "%" }}
            ></div>
          </div>

          <div className="w-full bg-gray-200 rounded-full h-1 dark:bg-gray-700 my-5">
            <div
              className="bg-primary h-1 rounded-full"
              style={{
                width:
                  label >= 8
                    ? "100%"
                    : (label - 3 < 0 ? 0 : label - 3) * 25 + "%",
              }}
            ></div>
          </div>

          <div className="w-full bg-gray-200 rounded-full h-1 dark:bg-gray-700 my-5">
            <div
              className="bg-primary h-1 rounded-full"
              style={{
                width:
                  label >= 9
                    ? "100%"
                    : (label - 8 < 0 ? 0 : label - 8) * 25 + "%",
              }}
            ></div>
          </div>
        </div>
        <div className="flex justify-between">
          <button
            className={`cursor-pointer flex rounded-full btn btn-filled-2`}
            style={{ borderRadius: "20px" }}
            onClick={() => setLabel(label - 1)}
          >
            Atras
          </button>
          {label == 9 ? (
            <button
              className={`cursor-pointer flex rounded-full btn btn-filled-2 ${loading ? "opacity-[0.5] cursor-not-allowed" : ""
                }`}
              style={{ borderRadius: "20px" }}
              name="save"
              onClick={(event) => onClick(event)}
            >
              {loading ? (
                <div className="w-6 h-6 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
              ) : (
                "Publicar anuncio"
              )}
            </button>
          ) : (
            <div>{next()}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PasosExcursion;
